import React from 'react'

const SendIcon = ({width="16",height="16"}) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.458158 5.9864C0.0666579 5.8559 0.0629079 5.64515 0.465658 5.5109L14.7809 0.739402C15.1777 0.607402 15.4049 0.829402 15.2939 1.2179L11.2034 15.5324C11.0909 15.9292 10.8622 15.9427 10.6942 15.5662L7.99866 9.50015L12.4987 3.50015L6.49866 8.00015L0.458158 5.9864Z" fill="#5D5FCC"/>
</svg>

)

export default SendIcon